import * as userSelectors from "../store/selectors/user/userSelectors";
import AccessDeniedDialog from "./common/AccessDeniedDialog";
import SettingsConsole from "components/settings/SettingsConsole";
import { connect } from "react-redux";

const SettingsApp = ({ isAdminUser }) => {
  return isAdminUser ? (
    <SettingsConsole />
  ) : (
    <AccessDeniedDialog
      message={"Your account does not have administrator privileges."}
    />
  );
};

const mapStateToProps = (state) => ({
  isAdminUser: userSelectors.isAdminUser(state),
});

export default connect(mapStateToProps)(SettingsApp);
